import { useState, useEffect } from "react";
import styles from "./index.module.scss";
import { UserType } from "../../types/userType";
import ProfilePreview from "../UserInterface/ProfilePreview";
import Button from "../Button";
import { CircleX } from "../Icons/general-interface-2";
import Modal from "../Modal";
import { Text } from "../Type";
import CareTeamSelect from "../CareTeamSelect";
import { isAuthorizer } from "../../utils/user";

type PropsType = {
  title: string;
  currUser?: UserType;
  careTeam: UserType[];
  editable?: boolean;
  onSave?: (users: UserType[]) => void;
};

const CareTeamSidebar = ({
  title,
  currUser,
  careTeam,
  editable,
  onSave,
}: PropsType) => {
  const [newUsers, setNewUsers] = useState<UserType[]>([]);
  const [users, setUsers] = useState<UserType[]>(careTeam);
  const [isOpen, setIsOpen] = useState(false);
  const role = currUser?.role.type;

  const handleSave = () => {
    setUsers([...users, ...newUsers]);
    setIsOpen(false);
  };

  useEffect(() => {
    setUsers(careTeam);
  }, [careTeam]);

  useEffect(() => {
    if (onSave) {
      onSave(users);
    }
  }, [users, onSave]);

  const handleRemove = (user: UserType) => {
    setUsers(users.filter((u) => u.id !== user.id));
  };

  if (!role) {
    return null;
  }

  return (
    <div className={styles.content}>
      <div className={styles.form}>
        <div className={styles.formHeader}>
          <div className={styles.formTitle}>{title}</div>
        </div>
        <div className={styles.profileSection}>
          <div className={styles.currProfile}>
            {currUser && currUser.role.type !== "administrator" && (
              <ProfilePreview user={currUser} size="medium" userRole />
            )}
          </div>
          {users &&
            users
              .filter((user) => user.id !== currUser?.id)
              .map((user) => (
                <div key={user.id} className={styles.addProfile}>
                  <ProfilePreview user={user} size="medium" userRole />
                  {editable && (
                    <button
                      className={styles.removeButton}
                      type="button"
                      onClick={() => handleRemove(user)}
                    >
                      <CircleX />
                      <br />
                      Remove
                    </button>
                  )}
                </div>
              ))}
          <div className={styles.addTeamMember}>
            {editable && (
              <>
                <Button secondary onClick={() => setIsOpen(true)}>
                  Add Care Team Member
                </Button>
              </>
            )}
          </div>
          <div className={styles.modalStyle}>
            {editable && (
              <Modal
                isOpen={isOpen}
                title="Add Care Team"
                onClose={() => setIsOpen(false)}
              >
                <Text className={styles.initText}>
                  You can add Motion{" "}
                  {!isAuthorizer(currUser) ? "and/or clinical care" : ""} team
                  members here.
                </Text>

                <Text size="large" className={styles.headingText}>
                  Add a care team member (optional)
                </Text>

                <div className={styles.select}>
                  <CareTeamSelect
                    onChange={setNewUsers}
                    excludedUserIds={users.map((user) => user.id)}
                    roleTypes={ isAuthorizer(currUser) ? undefined : undefined }
                  />
                </div>
                <div className={styles.modalButton}>
                  <Button primary onClick={handleSave}>
                    Add to Care Team
                  </Button>
                </div>
              </Modal>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default CareTeamSidebar;
